export function validarFormatoFecha(cadena) {
  let date = new Date(cadena);
  return date instanceof Date && !isNaN(date);
}